import React, { useEffect, useState } from "react";

import { Form, Upload, Spin, App } from "antd";
import {
  FileOutlined,
  FilePdfOutlined,
  LoadingOutlined,
} from "@ant-design/icons";

import { upload } from "../../../pages/api/https";
import { uploadFile } from "../../../pages/api/modules/User";
import Icon from "../../Icon";
import { faClose, faTrash } from "@fortawesome/free-solid-svg-icons";

const { Dragger } = Upload;

const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

const UIResumeUploader = ({
  setResumeScore = () => {},
  label,
  name,
  required,
  rules,
  index,
  onChange,
  validateStatus,
  hasFeedback,
  help,
  disabled,
  initialValue,
  defaultValue
}) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [imgName, setImgName] = useState(defaultValue || "");
  const [imageUrl , setImageUrl] = useState(initialValue );
  const { message } = App.useApp();
  useEffect(() => {
    if (defaultValue) {
      onChange(defaultValue);
    }
    // setFormResumeDefault(defaultValue);
  }, []);

  const beforeUpload = (file) => {
   const allowedTypes = [
      "application/pdf",
      // "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
    ];

    const isAllowed = allowedTypes.includes(file.type);

    if (!isAllowed) {
      message.error("You can only upload PDF or DOCX files!");
      return Upload.LIST_IGNORE;
    }
    
    const isLt20M = file.size / 1024 / 1024 <= 1;
    if (!isLt20M) {
      message.error("Failed : The resume size should not be greater than 1 MB.");
    }
    return isLt20M ? true : Upload.LIST_IGNORE;
  };

  const handleChange = async ({ fileList }) => {

    if (fileList.length > 0) {
      setLoading(true);
      const url = URL?.createObjectURL(fileList[0].originFileObj);
      const formData = new FormData();
      formData.append("file", fileList[0]?.originFileObj);
      const res = await uploadFile(formData);
      if (res?.Status === 1) {
        onChange(res?.Data?.Files?.FileName);
        setImgName(fileList[0]?.name);
        setLoading(false);
        sessionStorage.setItem("resume_"+name, JSON.stringify(fileList));
      } else {
        message.error(res?.Error);
      }
      setLoading(false);
    }
    setList(fileList);
  };

  useEffect(() => {
    if(defaultValue){
      sessionStorage.setItem("resume_"+name, JSON.stringify(defaultValue));
      return
    }
    const fileDetails = JSON.parse(sessionStorage.getItem("resume_"+name));
    const localFileDetails = JSON.parse(localStorage.getItem("fileDetails"));
    if (fileDetails || localFileDetails) {
      setImageUrl(fileDetails ? fileDetails[0]?.originFileObj : localFileDetails?.originFileObj);
        setImgName( fileDetails ? fileDetails[0]?.name : localFileDetails?.name);
      
    }
  }, []);

  const props = {
    name: "file",
    multiple: false,
    // action: "",
  };

  const removeResume = (e) => {
    e.stopPropagation();
    sessionStorage.removeItem("resume_"+name);
    setList([]);
    setImgName("");
    onChange();
    setResumeScore(0);
  }

  return (
    <Form.Item
      label={label}
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={initialValue}
      defaultValue={defaultValue}
    >
      <div style={{ width: "100%" }}>
        <Dragger
          {...props}
          name="file"
          accept=".pdf"
          maxCount={1}
          fileList={list}
          showUploadList={false}
          onChange={handleChange}
          beforeUpload={beforeUpload}
        >
          {

            imgName &&
            <div style={{position: 'absolute', top: 5, right: 6}} onClick={(e)=> removeResume(e)}>
            <Icon Icon={faClose} size={16} color="#373737e0" />
          </div>

          }

          {loading ? (
            <div style={{ marginBottom: 8 }}>
              <Spin indicator={antIcon} />
            </div>
          ) :
            <p className="ant-upload-drag-icon">
              <FilePdfOutlined />
            </p>
          }
          <p className="ant-upload-text">Resume {!required && <span style={{fontSize: 14, color: 'grey'}}>(Optional)</span> }</p>
          {imgName ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <p className="ant-upload-hint">
                <FileOutlined style={{ fontSize: 20 }} />
              </p>
              <p
                style={{ marginLeft: 10, fontSize: 20 }}
                className="ant-upload-hint"
              >
                {imgName }
              </p>
            </div>
          ) : (
              <p className="ant-upload-hint">
                Please upload your resume, Click or drag file to this area to
                upload<br />Supported formats: PDF. Max file size: 1 MB.
              </p>
          )}
        </Dragger>
      </div>
    </Form.Item>
  );
};

export default UIResumeUploader;
